module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "showSmallScreenOnly",
    class: _vm.colorBottomButton
  }, [_c('f7-fab', {
    staticClass: "leftfav4 button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.OpenFormsPage
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav3 button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.OpenFormsImportPage
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "list_bullet"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "showLargeScreenOnly fab-label"
  }, [_vm._v(_vm._s(_vm.$t('bank_accounts.add_bank_account')))])], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav2 button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.OpenFormListStatement
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "money_euro"
    }
  })], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": function($event) {
        return _vm.extractCSV()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "popoverName": ".popoverBanks",
      "subNavTitle": _vm.$i18n.t('common.item_list', {
        itemname: _vm.$t('leftPanelTitle.bk_accts')
      }),
      "menuAccess": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row rowBackgroundImage showLargeScreenOnly",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "row rowSearchBar"
  }, [_c('div', {
    staticClass: "firstButtonMarginLeft"
  }, [_c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": _vm.OpenFormsPage
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('bank_accounts.add_bank_account')))])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": _vm.OpenFormsImportPage
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "list_bullet"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('bank_accounts.imprt_bank_account')))])], 1), _vm._v(" "), _c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": _vm.OpenFormListStatement
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "money_euro"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('bank_accounts.view_statements')))])], 1), _vm._v(" "), _c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": function($event) {
        return _vm.extractCSV()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.extract_csv')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "containerCSV"
    }
  }), _vm._v(" "), _c('f7-searchbar', {
    staticClass: "search",
    attrs: {
      "id": "searchBankAccount",
      "cancel-link": "Cancel",
      "search-list": "#bank-list",
      "placeholder": "Search in Accounts"
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('cm-bank-accounts-list', {
    attrs: {
      "bankAccounts": _vm.bankAccounts,
      "filterBy": _vm.filterBy
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.paginationObject.firstIndex,
      "maxResultsByPage": _vm.paginationObject.maxResults,
      "nbResultsTotal": _vm.paginationObject.nbResultsTotal,
      "refreshEvent": _vm.paginationObject.refresh
    }
  }), _vm._v(" "), _c('f7-list', {
    staticClass: "searchbar-not-found"
  }, [_c('f7-list-item', {
    attrs: {
      "title": "Nothing found"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-49d59fb6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49d59fb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bankAccounts/CMBankAccountsPage.vue
// module id = 1665
// module chunks = 2